var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 116,
    viewBox: "0 0 117 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60098e-08 57.8123C6.31986e-08 42.4795 6.16338 27.7747 17.1343 16.9328C28.1051 6.09092 42.9848 -7.31878e-07 58.5 -9.96046e-07C74.0152 -1.26021e-06 88.8949 6.09092 99.8658 16.9328C110.837 27.7747 117 42.4795 117 57.8123C117 73.1451 110.837 87.8498 99.8658 98.6917C88.8949 109.534 74.0152 115.625 58.5 115.625C42.9848 115.625 28.1051 109.534 17.1343 98.6917C6.16338 87.8498 1.08821e-07 73.1451 8.60098e-08 57.8123H8.60098e-08ZM55.1616 82.5559L88.842 40.9465L82.758 36.1365L54.0384 71.6024L33.696 54.8523L28.704 60.7723L55.1616 82.5637L55.1616 82.5559Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessChecked);
export default __webpack_public_path__ + "static/media/successChecked.cccd06d4f3d60496d27366b381a046fc.svg";
export { ForwardRef as ReactComponent };